import React, { useCallback, useEffect } from 'react'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import {
  selectCrossClientLandingPollingEnabled,
  selectCrossClientRunningExecutions,
  setCrossClientRunningExecutionProgress,
  startCrossClientLandingPolling,
  stopCrossClientLandingPolling,
} from '../../../../store/crossClient/crossClientLanding'
import { useLazyGetCrossClientQueryExecutionProgressQuery } from '../../../../store/crossClient/crossClient'
import { usePollingEffect } from '../../../../apps/professional-app/fa/common/hooks/usePollingEffect'

export const CrossClientRunningExecutionsPoller: React.FC = () => {
  const dispatch = useAppDispatch()

  const accountId = useAppSelector(selectAccountId)
  const runningExecutions = useAppSelector(selectCrossClientRunningExecutions)
  const pollingEnabled = useAppSelector(selectCrossClientLandingPollingEnabled)

  const [triggerGetCrossClientQueryProgress] = useLazyGetCrossClientQueryExecutionProgressQuery()

  useEffect(() => {
    if (runningExecutions.length) {
      dispatch(startCrossClientLandingPolling())
    } else {
      dispatch(stopCrossClientLandingPolling())
    }
  }, [dispatch, runningExecutions.length])

  const getCrossClientRunningExecutionProgress = useCallback(async () => {
    try {
      const progresses = []
      for (const execution of runningExecutions) {
        const progress = await triggerGetCrossClientQueryProgress({ accountId, executionId: execution.id }).unwrap()
        if (progress) {
          progresses.push(progress)
        }
      }
      if (progresses.length) {
        dispatch(setCrossClientRunningExecutionProgress(progresses))
      }
    } catch (e) {
      console.error(e)
      dispatch(stopCrossClientLandingPolling())
    }
  }, [dispatch, accountId, runningExecutions, triggerGetCrossClientQueryProgress])

  const { start: startCrossClientRunningExecutionPolling, stop: stopCrossClientRunningExecutionPolling } = usePollingEffect(
    getCrossClientRunningExecutionProgress,
    [],
    {
      interval: 10000,
    },
  )

  useEffect(() => {
    if (pollingEnabled) {
      startCrossClientRunningExecutionPolling()
    } else {
      stopCrossClientRunningExecutionPolling()
    }
  }, [pollingEnabled, startCrossClientRunningExecutionPolling, stopCrossClientRunningExecutionPolling])

  return null
}
